let csrfToken = "";

async function request(path, options = {}) {
  const headers = new Headers(options.headers ?? {});
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (options.method && !["GET", "HEAD", "OPTIONS"].includes(options.method)) headers.set("X-CSRF-Token", csrfToken);
  const response = await fetch(path, { credentials: "same-origin", ...options, headers });
  if (response.status === 401) throw new APIError(401, "Authentication required");
  if (!response.ok) {
    let detail = `Request failed (${response.status})`;
    try { detail = (await response.json()).detail ?? detail; } catch { /* response was not JSON */ }
    throw new APIError(response.status, detail);
  }
  if (response.status === 204) return null;
  return response.json();
}

export class APIError extends Error {
  constructor(status, message) { super(message); this.status = status; }
}

export async function login(password) {
  const result = await request("/api/login", { method: "POST", body: JSON.stringify({ password }) });
  csrfToken = result.csrfToken;
}

export async function bootstrap() {
  const result = await request("/api/bootstrap");
  csrfToken = result.csrfToken;
  return result;
}

export async function logout() {
  await request("/api/logout", { method: "POST" });
  csrfToken = "";
}

export const updateTask = (id, update) => request(`/api/tasks/${encodeURIComponent(id)}`, { method: "PATCH", body: JSON.stringify(update) });
export const saveCheckin = (checkin) => request("/api/checkins", { method: "POST", body: JSON.stringify(checkin) });
export const reschedule = (fromDate) => request("/api/reschedule", { method: "POST", body: JSON.stringify({ fromDate }) });
export const saveCapacity = (date, minutes, reason) => request(`/api/capacity/${encodeURIComponent(date)}`, { method: "PUT", body: JSON.stringify({ minutes, reason }) });
export const deleteCapacity = (date) => request(`/api/capacity/${encodeURIComponent(date)}`, { method: "DELETE" });
